import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link } from '@mui/material';

import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TivityLogo from './TivityLogo';
import LanguageSwitcher from './LanguageSwitcher';
import MobileNavDrawer from './MobileNavDrawer';

const pages = ['home', 'races'] as const;

const pageNameToRoute: Record<string, string> = {
  home: '/',
  races: '/races',
};

function ResponsiveAppBar() {
  const { t } = useTranslation();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const currentRoute = location.pathname; // Extract the current route path

  // Use currentRoute to determine the activePage
  const activePage = Object.keys(pageNameToRoute).find(
    (page) => pageNameToRoute[page] === currentRoute
  );

  const handleOpenNavMenu = () => {
    setDrawerOpen(true);
  };

  const handleCloseNavMenu = () => {
    setDrawerOpen(false);
  };

  const handlePageChange = (page: string) => {
    const route = pageNameToRoute[page];

    if (route) {
      navigate(route);
    }

    handleCloseNavMenu();
  };

  return (
      <AppBar position="static" color="primary">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label={t('nav.openMenu')}
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <MobileNavDrawer
                open={drawerOpen}
                onClose={handleCloseNavMenu}
                items={pages.map((page) => ({
                  key: page,
                  label: t(`nav.${page}`),
                  onClick: () => handlePageChange(page),
                }))}
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <Button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  sx={{
                    my: 2,
                    color: activePage === page ? 'primary.dark' : 'white',
                    display: 'block',
                    backgroundColor: activePage === page ? 'secondary.light' : '', // Change button color for the active page
                  }}
                >
                  {t(`nav.${page}`)}
                </Button>
              ))}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'center' }}>
              <Link href="/" underline="none">
                <TivityLogo variant="light" />
              </Link>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <LanguageSwitcher variant="light" />
              <Button href="/login" component={Link} variant="contained" color='button'>
                  {t('nav.login')}
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
  );
}

export default ResponsiveAppBar;
